<template>
    <div class="photo-upload" :class="{preview: isPreviewMode}" @click.stop>
        <div class="title" v-show="!isPreviewMode">
            <div class="left">
                附上照片
            </div>
            <div class="right" @click="onEdit">
                {{ value.length > 0 ? '編輯' : '讓騎士更清楚地點/內容/商品樣貌' }}
            </div>
        </div>
        <div class="photos">
            <div class="photo" v-for="(photo, index) in value.slice(0, 3)" :key="index" :style="{'background-image': `url(${isBase64 ? photo.content : photo.url})`, opacity: opacity, height: height}" @click="onEdit(index)"/>
            <div class="count" v-if="value.length > 3" @click="onEdit(2)">
                <div>+ {{ value.length - 3 }}</div>
            </div>
        </div>
        <div class="imgs" v-if="isPreviewMode">
            <img v-for="(photo, index) in value" :key="index" :src="imgUrl(photo)" v-gallery="'location-group-' + groupId" ref="locationPhotos">
        </div>
        <photo-editor @updatePic="updatePic" ref="photoEditor"/>
    </div>
</template>

<script>
    import PhotoEditor from "./PhotoEditor";

    export default {
        name: "PhotoUploader",
        components: {
            'photo-editor': PhotoEditor,
        },
        props: {
            value: {
                require: true,
                type: Array,
            },
            isPreviewMode: {
                default: false,
                type: Boolean,
            },
            isBase64: {
                default: true,
                type: Boolean,
            },
            groupId: {
                default: 0,
            },
            opacity: {
                default: 1,
                type: Number,
            },
            height: {
                default: 'auto',
                type: String,
            }
        },
        methods: {
            imgUrl(photo) {
                return this.isBase64 ? photo.content : photo.url;
            },
            onEdit(index) {
                window.scrollTo(0,0);
                if (this.isPreviewMode) {
                    if (this.$refs.locationPhotos) this.$refs.locationPhotos[index].click();
                    return;
                }

                window.location.hash = 'photo';
                this.$refs.photoEditor.show(this.value);
            },
            updatePic(photos) {
                if (this.isPreviewMode) return;
                this.$emit('input', photos);
            },
        },
        watch: {
            '$route'() {
                let hash = this.$route.hash.replace('#', '');

                if (hash !== 'photo') {
                    this.$refs.photoEditor.hidden();
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .photo-upload {
        background-color: #FFFFFF;
        box-shadow: 0 2px 8px 0 rgba(51,153,51,0.35);
        border-radius: 5px;
        margin: 15px 15px 0 15px;
        padding: 10px 15px;
        user-select: none;

        .imgs {
            display: none;
        }

        &.preview {
            box-shadow: none;
            margin: 0;
            padding: 0;
        }

        .title {
            display: flex;
            justify-content: space-between;
            color: #4a4a4a;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;

            .right {
                color: #9b9b9b;
                cursor: pointer;
            }
        }

        .photos {
            display: flex;
            position: relative;

            .count {
                cursor: pointer;
                position: absolute;
                right: calc(((100% / 3) - 55px) / 2);
                top: calc(50% - 25px);
                background-color: rgba(0,0,0,.3);
                color: white;
                border-radius: 90px;
                font-size: 30px;
                width: 50px;
                height: 50px;
                text-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .photo {
                width: calc((100% / 3) - 10px);
                margin: 5px;
                border-radius: 5px;
                background-position: 50% 50%;
                background-size: cover;
                background-repeat: no-repeat;
                position: relative;
                background-color: #D8D8D8;
                box-shadow: 0 2px 8px 0 rgba(51,153,51,0.35);
                cursor: pointer;

                &:after {
                    content: " ";
                    display: block;
                    padding-bottom: 100%;
                }

                .delete {
                    padding: 5px;
                    position: absolute;
                    bottom: 10px;
                    right: 10px;
                    cursor: pointer;
                }
            }
        }
    }
</style>